module.exports = __webpack_public_path__ + "static/img/logo2.510dc7b1.png";